import { useIntl } from "react-intl";

const DeploymentGating = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DeploymentGating.header",
            defaultMessage: "Deployment gating"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DeploymentGating.body",
            defaultMessage:
                "Allow or prevent deployments at specific points in the change management process using a CI/CD tool that you’ve connected to Jira Service Management."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default DeploymentGating;
